import React from "react"
import FormComposer from "@components/form/components/FormComposer"
import { SectionTypes, FieldTypes } from "@components/form/common"
import schema, { initialValues, withRecaptcha } from "./schema"

interface RequestQuoteProps {
  industries: Array<{
    industry: string
    email: string
  }>
  onSubmit: any
  errorMessage?: string
  isLoading: boolean
}

const RequestQuoteForm: React.FC<RequestQuoteProps> = ({
  industries = [],
  onSubmit,
  errorMessage,
  isLoading,
}) => {
  const projectFields: any = [
    {
      type: FieldTypes.Select,
      name: "industry",
      label: "Industry*",
      placeholder: "Industry",
      options: industries.map((industry) => ({
        label: industry.industry,
        value: industry.industry,
      })),
    },
    {
      type: FieldTypes.Text,
      name: "projectStart",
      label: "How soon would your project begin?*",
      placeholder: "How soon would your project begin?",
    },
    {
      type: FieldTypes.Text,
      name: "quantityNeeded",
      label: "Quantity needed*",
      placeholder: "Quantity needed",
    },
    {
      type: FieldTypes.TextArea,
      name: "message",
      label: "Message*",
      placeholder: "message",
    },
  ]

  const useRecaptcha = process.env.NEXT_PUBLIC_VERCEL_ENV === "production"

  if (useRecaptcha) {
    projectFields.push({
      type: FieldTypes.Recaptcha,
      name: "recaptcha",
      label: "Recaptcha",
    })
  }

  return (
    <FormComposer
      schema={useRecaptcha ? withRecaptcha : schema}
      formId="request-quote-form"
      initialValues={initialValues}
      sections={[
        {
          type: SectionTypes.Row,
          label: "Contact Information",
          fields: [
            {
              type: FieldTypes.Text,
              name: "firstName",
              label: "First Name*",
              placeholder: "First Name",
            },
            {
              type: FieldTypes.Text,
              name: "lastName",
              label: "Last Name*",
              placeholder: "Last Name",
            },
            {
              type: FieldTypes.Text,
              name: "email",
              label: "Email Address*",
              placeholder: "Email Address",
            },
            {
              type: FieldTypes.Text,
              name: "phoneNumber",
              label: "Phone Number*",
              placeholder: "Phone Number",
            },
          ],
        },
        {
          type: SectionTypes.Column,
          label: "Company Information",
          fields: [
            {
              type: FieldTypes.Text,
              name: "companyName",
              label: "Company Name*",
              placeholder: "Company Name",
            },
            {
              type: FieldTypes.Text,
              name: "companyWebsite",
              label: "Company Website",
              placeholder: "Company Website",
            },
            {
              type: FieldTypes.Text,
              name: "address",
              label: "Street Address*",
              placeholder: "Street Address",
            },
            {
              type: FieldTypes.Text,
              name: "address2",
              label: "Street Address 2",
              placeholder: "Street Address 2",
            },
            {
              type: FieldTypes.Text,
              name: "city",
              label: "City*",
              placeholder: "City",
            },
            {
              type: FieldTypes.Text,
              name: "stateProvince",
              label: "State or Province*",
              placeholder: "State or Province",
            },
            {
              type: FieldTypes.Text,
              name: "zip",
              label: "Zip / Postal Code*",
              placeholder: "Zip / Postal Code",
            },
            {
              type: FieldTypes.Text,
              name: "country",
              label: "Country*",
              placeholder: "Country",
            },
          ],
        },
        {
          type: SectionTypes.Column,
          label: "Your Projects",
          fields: projectFields,
        },
      ]}
      submitText="Send Request"
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      isLoading={isLoading}
    />
  )
}

export default RequestQuoteForm
